import React from 'react';
import DefaultHeader from 'components/UI/V3/DefaultHeader/DefaultHeader';
import ClientMembershipsFilters from './ClientMembershipsFilters';
import styles from './ClientMemberships.module.scss';
import { usePermissions } from 'hooks/usePermissions';

interface ClientMembershipsHeaderProps {
    selectedFilter: string;
    selectedFilterCount: number | null;
    searchText: string;
    onSellMembership: () => void;
    onSelectFilter: (value: string) => void;
    onChangeSearchText: (value: string) => void;
}

export const ClientMembershipsHeader: React.FC<ClientMembershipsHeaderProps> = ({
    selectedFilter,
    selectedFilterCount,
    searchText,
    onSellMembership,
    onSelectFilter,
    onChangeSearchText
}) => {
    const permissions = usePermissions();
    return (
        <div className={styles.headWrapper}>
            <DefaultHeader
                title={<span className={styles.headerTitle}>Memberships</span>}
                className={styles.headerContainer}
                buttonLabel={permissions.memberships.sell ? 'Sell Membership' : undefined}
                displayButton={permissions.memberships.sell}
                onClick={permissions.memberships.sell ? onSellMembership : undefined}
            />

            <ClientMembershipsFilters
                selectedFilter={selectedFilter}
                selectedFilterCount={selectedFilterCount}
                searchText={searchText}
                onSelectFilter={onSelectFilter}
                onChangeSearchText={onChangeSearchText}
            />
        </div>
    );
};

export default ClientMembershipsHeader;
